<app-content-w-header header="Processing">
  <mat-card class="toolbar subheader">
    <div class="dx-fieldset" style="">
      <!--      <dx-toolbar>-->
      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <div style="display: flex; align-items: center">
        <dx-date-box #from width="100px" [(value)]="selectedFromValue"
                     (onValueChanged)='from_onValueChanged($event)'></dx-date-box>
        <span>&nbsp;&ndash;&nbsp;</span>
        <dx-date-box #to width="100px" [(min)]="selectedFromValue" [(value)]="selectedToValue"></dx-date-box>
      </div>
      <!--        </dxi-item>-->

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <dx-select-box
        width="250px"
        [dataSource]="facilityDso"
        [displayExpr]="'name'"
        valueExpr="id"
        [(value)]="facilityId"
        placeholder="Facility"
        [showClearButton]="true"
        itemTemplate="item"
        (onSelectionChanged)="facility_onSelectionChanged($event)"
      >
        <ng-container *dxTemplate="let data of 'item'">
          <small><strong>[{{ data.shortname }}]</strong> {{ data.name }}</small>
        </ng-container>
      </dx-select-box>
      <!--        </dxi-item>-->

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <dx-select-box
        [dataSource]="serviceTypes"
        [(value)]="serviceType"
        [showClearButton]="true"
        placeholder="Service Type"
        width="110px"
      ></dx-select-box>
      <!--        </dxi-item>-->

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <dx-select-box
        [dataSource]="['KEYSTONE', 'AMERIHEALTH', 'PHW', 'UPMC', 'Other']"
        [(value)]="mco"
        [showClearButton]="true"
        placeholder="MCO"
        width="70px"
      ></dx-select-box>
      <!--        </dxi-item>-->

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <dx-select-box
        [dataSource]="['CTS', 'MTM', 'LGTC']"
        [(value)]="broker"
        [showClearButton]="true"
        placeholder="Broker"
        width="80px"
      ></dx-select-box>
      <!--        </dxi-item>-->

      <!--      <dx-select-box-->
      <!--        [dataSource]="[{t: 'Has UnUtilized TripID', v: true}, {t: 'Has no UnUtilized TripID', v: false}]"-->
      <!--        displayExpr="t"-->
      <!--        valueExpr="v"-->
      <!--        [(value)]="hasUnusedTrips"-->
      <!--        [showClearButton]="true"-->
      <!--        placeholder="has UnUtilized TripID..."-->
      <!--        width="185px"-->
      <!--      ></dx-select-box>-->

      <dx-select-box
        [dataSource]="[
          { t: 'Client has TripID on the day of service', v: true },
          { t: 'Client has No TripID on the day of service', v: false }
        ]"
        displayExpr="t"
        valueExpr="v"
        [(value)]="existTripIds"
        [showClearButton]="true"
        placeholder="Client's TripID State..."
        width="270px"
      ></dx-select-box>

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <dx-select-box
        [dataSource]="[
          { t: 'Service Has TripID Assigned', v: true },
          { t: 'Service Has No TripIDs Assigned', v: false }
        ]"
        displayExpr="t"
        valueExpr="v"
        [(value)]="hasTripAssigned"
        [showClearButton]="true"
        placeholder="Service to TripID Assignment..."
        width="200px"
      ></dx-select-box>
      <!--        </dxi-item>-->

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <dx-select-box
        [dataSource]="[
          { t: 'Service Has Claim', v: true },
          { t: 'Service Has No Claim', v: false }
        ]"
        displayExpr="t"
        valueExpr="v"
        [(value)]="hasClaim"
        [showClearButton]="true"
        placeholder="Select Claim State..."
        width="150px"
      ></dx-select-box>
      <!--        </dxi-item>-->

      <dx-select-box
        [dataSource]="ClaimStatuses"
        [(value)]="claimStatus"
        [showClearButton]="true"
        placeholder="Select Claim Status..."
        width="160px"
      ></dx-select-box>

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <dx-text-box width="100px" [(value)]="mci" placeholder="MCI"></dx-text-box>
      <!--        </dxi-item>-->

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <app-employee-drop-down-grid
        [(value)]="driverId"
        [filter]="[]"
        [dataSource]="employeeDso"
        [grid_columns]="[
          {
            dataField: 'tenantId',
            caption: 'Tenant',
            lookup: {
              dataSource: facilityDso,
              valueExpr: 'id',
              displayExpr: 'shortname'
            }
          },
          { dataField: 'person_firstname', caption: 'Firstname' },
          { dataField: 'person_lastname', caption: 'Lastname' }
        ]"
        [showClearButton]="true"></app-employee-drop-down-grid>

      <!--          <dx-select-box-->
      <!--            [dataSource]="[]"-->
      <!--            [(value)]="driverId"-->
      <!--            placeholder="Driver"-->
      <!--            [showClearButton]="true"-->
      <!--          ></dx-select-box>-->
      <!--        </dxi-item>-->

      <!--        <dxi-item [location]="'before'" locateInMenu="auto">-->
      <app-consumer-drop-down-grid
        [(value)]="clientId"
        [filter]="[]"
        [dataSource]="consumerDso"
        [grid_columns]="[
          { dataField: 'mci', caption: 'MCI' },
          {
            dataField: 'tenantId',
            caption: 'Tenant',
            lookup: {
              dataSource: facilityDso,
              valueExpr: 'id',
              displayExpr: 'shortname'
            }
          },
          { dataField: 'person_firstname', caption: 'Firstname' },
          { dataField: 'person_lastname', caption: 'Lastname' }
        ]"
        [showClearButton]="true"></app-consumer-drop-down-grid>

      <!--          <dx-select-box-->
      <!--            [dataSource]="[]"-->
      <!--            [(value)]="clientName"-->
      <!--            placeholder="Client Name"-->
      <!--            [showClearButton]="true"-->
      <!--          ></dx-select-box>-->

      <!--        </dxi-item>-->

      <dx-select-box
        [dataSource]="validationStates"
        displayExpr="t"
        valueExpr="v"
        [(value)]="validationState"
        [showClearButton]="true"
        placeholder="Validation Status"
        width="130px"></dx-select-box>


      <dx-check-box [(value)]="withDriverSigns" text="With Driver Signs"></dx-check-box>
      <dx-check-box [(value)]="withEscortSigns" text="With Escort Signs"></dx-check-box>

      <!--        <dxi-item location="after" locateInMenu="auto">-->
      <div style="display: inline-block">
        <dx-button style="text-align: left" type="default" text="Filter" (onClick)="filter()"></dx-button>
      </div>
      <!--        </dxi-item>-->

      <!--      </dx-toolbar>-->
    </div>

    <dx-popover #popover
                style="position: absolute"
                [(visible)]="isPopoverVisible"
                [target]="popoverTargetSelector"
                [contentTemplate]="currentPopoverTemplate"
    >
      <ng-container *dxTemplate="let data of 'mealImg'">
        <div style="width: 500px; height: 500px; display: flex; justify-content: center; align-items: center;">
          <img style="max-width: 100%; max-height: 100%;"
               [src]="popoverData | pictureLink: 'resize--600' | async | sanitizeUrl" />
        </div>
      </ng-container>

      <ng-container *dxTemplate="let data of 'addrMismatch'">
        <div>
          [service origin: <strong>{{ popoverData?._addresses?.service?.from }}</strong>] ->
          [service dest: <strong>{{ popoverData?._addresses?.service?.to }}</strong>]
        </div>

        <div>
          [trip origin: <strong>{{ popoverData?._addresses?.trip?.from }}</strong>] ->
          [trip dest: <strong>{{ popoverData?._addresses?.trip?.to }}</strong>]
        </div>
      </ng-container>
    </dx-popover>

    <dx-tooltip #tooltip
                style="position: absolute"
                [(visible)]="isTooltipVisible"
                [target]="tooltipTargetSelector"
                [contentTemplate]="currentTooltipTemplate"
    >
      <ng-container *dxTemplate="let data of 'trip'">
        <span
          [innerHTML]="tooltipData?._trip?._tripId | tripPopup:tooltip:tooltipData?._trip?._broker:tooltipData?._trip?._date | async | sanitizeHtml"
        ></span>
      </ng-container>
    </dx-tooltip>

  </mat-card>

  <dx-data-grid
    class="content"
    height="100%"
    [dataSource]="dso"

    [stateStoring]="grid_stateStoring"
    [twoWayBindingEnabled]="false"
    [repaintChangesOnly]="true"

    [errorRowEnabled]="false"
    [searchPanel]="{ visible: false }"
    [headerFilter]="{ visible: true }"
    [filterRow]="{ visible: true }"
    [filterPanel]="{ visible: true }"
    [columnChooser]="{enabled: true, mode: 'select'}"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    [rowAlternationEnabled]="true"

    (onInitialized)="grid_onInitialized($event)"
    (onDataErrorOccurred)="grid_onDataErrorOccurred($event)"
    (onSaving)="grid_onSaving($event)"
    (onSaved)="grid_onSaved($event)"

    (onToolbarPreparing)="grid_onToolbarPreparing($event)"
    (onContextMenuPreparing)="grid_onContextMenuPreparing($event)"

    (onCellPrepared)="grid_onCellPrepared($event)"
    (onCellClick)="grid_onCellClick($event)"
    (onSelectionChanged)="grid_onSelectionChanged($event)"
    (onCellHoverChanged)="grid_onCellHoverChanged($event)"
  >
    <dxo-paging [enabled]="true" [pageSize]="50"></dxo-paging>
    <dxo-pager [visible]="true" [showInfo]="true" [showPageSizeSelector]="true" [showNavigationButtons]="true"
               [allowedPageSizes]="[50, 100]"></dxo-pager>

    <dxo-grouping [contextMenuEnabled]="true"></dxo-grouping>
    <dxo-group-panel [visible]="true"></dxo-group-panel>

    <dxo-selection [mode]="'multiple'" [selectAllMode]="'page'"></dxo-selection>

    <dxo-editing [allowAdding]="false" [allowDeleting]="false" [allowUpdating]="false"></dxo-editing>

    <dxo-scrolling
      [useNative]="true"
    ></dxo-scrolling>
    <!--    mode="virtual"-->
    <!--    [preloadEnabled]="true"-->
    <!--    rowRenderingMode="virtual"-->
    <!--    columnRenderingMode="virtual"-->

    <dxo-export [enabled]="true" fileName="claims-export"></dxo-export>

    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

    <!-- region Columns -->

    <!--<dxi-column type="selection" [sortIndex]="0"></dxi-column>-->

    <dxi-column
      caption="Issues"
      dataField="__issueHash"
      [allowEditing]="false"
      fixedPosition="left"
      [fixed]="true"
      [showInColumnChooser]="false"
      [allowGrouping]="false"
      cellTemplate="issues_cell"
      [minWidth]="30"
    ></dxi-column>

    <dxi-column caption="Batch State" dataField="getBatchStatus" dataType="string"></dxi-column>

    <dxi-column caption="Batch Count" dataField="getBatchCount" dataType="number"></dxi-column>

    <dxi-column caption="Last Batch" dataField="_lastBatchCtime" dataType="date"></dxi-column>

    <dxi-column caption="Validation Status" dataField="validationState" dataType="string">
      <dxo-lookup [dataSource]="validationStates" valueExpr="v" displayExpr="t"></dxo-lookup>
    </dxi-column>

    <dxi-column caption="Facility" dataField="_tenant.name" dataType="string"></dxi-column>

    <dxi-column
      caption="Date"
      dataField="vdate"
      dataType="date"
      format="shortDate"
      [editorOptions]="{ type: 'date', displayFormat: 'shortDate' }"
    ></dxi-column>

    <dxi-column caption="MCI" dataField="consumer_mci"></dxi-column>
    <dxi-column caption="Client Last Name" dataField="consumer_person_lastname"></dxi-column>
    <dxi-column caption="Client First Name" dataField="consumer_person_firstname"></dxi-column>

    <dxi-column caption="Employee Last Name" dataField="employee_person_lastname"></dxi-column>
    <dxi-column caption="Employee First Name" dataField="employee_person_firstname"></dxi-column>

    <dxi-column caption="Vehicle" dataField="vehicle_internalId" dataType="string"></dxi-column>

    <dxi-column caption="Manifest Rec" dataField="manifestRecId"></dxi-column>

    <dxi-column caption="Marker" dataField="marker"></dxi-column>

    <!--    -->

    <dxi-column caption="Service Type" dataField="vServiceType" dataType="string"></dxi-column>

    <dxi-column caption="MCO" dataField="_client.mco" dataType="string"></dxi-column>
    <dxi-column caption="Broker" dataField="_client.broker" dataType="string"></dxi-column>

    <!--    <dxi-column caption="Trip ID"-->
    <!--                dataField="_trip._tripId"-->
    <!--    ></dxi-column>-->

    <dxi-column caption="Trip ID" dataField="_trip._tripId" cellTemplate="tripId_cell"></dxi-column>

    <dxi-column caption="All TripIDs per Client" dataField="_trips.length"></dxi-column>

    <dxi-column caption="Claim Status" dataField="_trip.__claim.__status"></dxi-column>

    <dxi-column caption="Origin" dataField="_rec.origin" dataType="string"></dxi-column>

    <dxi-column caption="Destination" dataField="_rec.destination" dataType="string"></dxi-column>

    <dxi-column caption="Cancelled" dataField="_cancelled" dataType="boolean"></dxi-column>

    <dxi-column caption="Per Client Signatures Count" dataField="_consCount" dataType="number"></dxi-column>

    <!--    <dxi-column caption="Meals Units" dataField="vTotalMealsUnits" dataType="number"></dxi-column>-->
    <dxi-column caption="Units" dataField="vUnits" dataType="number"></dxi-column>

    <dxi-column
      caption="Client Signature"
      dataField="imgFileId"
      cellTemplate="signature_cell"
      [allowSearch]="false"
      [allowFiltering]="false"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      [allowGrouping]="false"
    ></dxi-column>

    <dxi-column
      caption="Driver Signature"
      dataField="_driverSign.imgFileId"
      cellTemplate="signature_cell"
      [allowSearch]="false"
      [allowFiltering]="false"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      [allowGrouping]="false"
    ></dxi-column>

    <dxi-column
      caption="Attendant Signature"
      dataField="_escortSign.imgFileId"
      cellTemplate="signature_cell"
      [allowSearch]="false"
      [allowFiltering]="false"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      [allowGrouping]="false"
    ></dxi-column>

    <dxi-column
      caption="Meal Photo"
      dataField="meta.mealPhoto"
      cellTemplate="mealPhoto_cell"
      [allowSearch]="false"
      [allowFiltering]="false"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      [allowGrouping]="false"
    ></dxi-column>

    <dxi-column
      caption="Mismatch Location"
      dataField="__addrMismatch"
      cellTemplate="addrMismatch_cell"
      [allowSearch]="false"
      [allowFiltering]="false"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      [allowGrouping]="false"
    >
      <!--      <dxo-lookup [dataSource]="['dest', 'origin', 'both', 'swapped', 'valid']"></dxo-lookup>-->
    </dxi-column>

    <dxi-column
      caption="TripId Multi Assigned"
      dataField="__tripIdsMultiAssigned"
      cellTemplate="__tripIdsMultiAssigned_cell"
      [allowSearch]="false"
      [allowFiltering]="false"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      [allowGrouping]="false"
    >
      <!--      <dxo-lookup [dataSource]="['dest', 'origin', 'both', 'swapped', 'valid']"></dxo-lookup>-->
    </dxi-column>

    <dxi-column
      caption="ARR/PU/DO"
      cellTemplate="arrPuDoTimes_cell"
      [allowSearch]="false"
      [allowFiltering]="false"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      [allowGrouping]="false"
    ></dxi-column>

    <!-- endregion Columns -->

    <!-- region Templates -->

    <ng-container *dxTemplate="let cellInfo of 'issues_cell'">
      <ng-container *ngIf="cellInfo.data?.__issueHash; else emptyTpl">
        <mat-icon class="warning" fontSet="fas" fontIcon="fa-exclamation-triangle" style="font-size: 1em;"></mat-icon>
      </ng-container>

      <small>&nbsp;</small>

      <ng-container *ngIf="cellInfo.data.meta.locked; else emptyTpl">
        <mat-icon fontSet="fas" fontIcon="fa-lock"
                  style="font-size: 1em; color: darkslateblue; opacity: 0.7;"></mat-icon>
      </ng-container>

      <ng-template #emptyTpl>
        <mat-icon fontSet="fas" fontIcon="fa-circle" style="font-size: 1em; color: rgba(255,255,255,0);"></mat-icon>
      </ng-template>
    </ng-container>

    <ng-container *dxTemplate="let cellInfo of 'tripId_cell'">
      <div style="display: flex; flex-direction: row; align-items: center; gap: 0.5em;">
        <ng-container *ngIf="!cellInfo.data._locked(); else outTripIdCell">
          <dx-select-box
            [dataSource]="tripDsoMap.get(cellInfo.key)"
            valueExpr="_tripId"
            displayExpr="_tripId"
            [placeholder]="cellInfo.data?._trips?.length === 0
                ? cellInfo.data?.vTripId
                  ? cellInfo.data?.vTripId
                  : 'No Trips'
                : 'Select...'"
            [value]="cellInfo.data?._trip?._tripId"
            [readOnly]="cellInfo.data._locked()"
            [showClearButton]="true"

            (onSelectionChanged)="tripId_onSelectionChanged(cellInfo, $event)"
            (onValueChanged)="tripId_onValueChanged(cellInfo, $event)"
          ></dx-select-box>
        </ng-container>

        <ng-template #outTripIdCell>
          <div
            style="line-height: 2em; padding: 0 5px; border-radius: 4px; overflow: hidden;"
            [ngStyle]="{border: cellInfo.data._locked() ? '1px dashed lightgray' : '1px solid gray', color: cellInfo.data._locked() ? 'gray' : 'black'}"
            [innerHTML]="(cellInfo.data?._trip?._tripId || cellInfo.data?.vTripId || (cellInfo.data?._trips?.length === 0 ? 'No Trips' : '&nbsp;')) | sanitizeHtml"
          ></div>
        </ng-template>

        <ng-container *ngIf="cellInfo.data?._trip?._tripId">
          <div
            style="cursor: pointer; position: relative;"
            [id]="'trip_id_info_' + cellInfo.data.id"
            (click)="showTooltip3(cellInfo)"
          >ⓘ
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *dxTemplate="let cellInfo of 'signature_cell'">
      <ng-container *ngIf="cellInfo.value">
        <img
          style="max-height: 20px"
          [src]="cellInfo.value | signatureLink: 'FILE':'resize--20/trim' | async | sanitizeUrl" />
      </ng-container>
    </ng-container>

    <ng-container *dxTemplate="let cellInfo of 'mealPhoto_cell'">
      <ng-container *ngIf="cellInfo.value">
        <img
          style="max-height: 20px; cursor: pointer;"
          [id]="'mealImg_' + cellInfo.data.id"
          [src]="cellInfo.value | pictureLink: 'resize-20-/trim' | async | sanitizeUrl"
          (click)="showPopover1(cellInfo)"
        />
      </ng-container>

    </ng-container>

    <ng-container *dxTemplate="let cellInfo of 'arrPuDoTimes_cell'">
      <small
        style="cursor: pointer;"
        [id]="'timesPuDo_' + cellInfo.data.id"
      >
        <!--        <div *ngIf="cellInfo.data?.scheduledTime">sch: {{cellInfo.data?.scheduledTime}}</div>-->

        <div *ngIf="cellInfo.data?.arrivedTime"
             [ngClass]="{ 'PuDo-warning': cellInfo.data?.__issueFields?.arrivedTime }">
          arr: {{ cellInfo.data.arrivedTime }}
        </div>

        <div *ngIf="cellInfo.data.pickupTime"
             [ngClass]="{ 'PuDo-warning': cellInfo.data?.__issueFields?.pickupTime }">
          pu: {{ cellInfo.data.pickupTime }}
        </div>

        <div *ngIf="cellInfo.data.dropoffTime"
             [ngClass]="{ 'PuDo-warning': cellInfo.data?.__issueFields?.dropoffTime }">
          do: {{ cellInfo.data.dropoffTime }}
        </div>

      </small>
    </ng-container>

    <ng-container *dxTemplate="let cellInfo of 'addrMismatch_cell'">
      <div
        style="cursor: pointer;"
        [id]="'c_' + cellInfo.data.id + '__addrMismatch'"
        (click)="showPopover2(cellInfo)"
      >{{ cellInfo.value }}&nbsp;ⓘ
      </div>
    </ng-container>

    <ng-container *dxTemplate="let cellInfo of '__tripIdsMultiAssigned_cell'">
      {{ cellInfo.value }}
    </ng-container>

    <!--    -->

    <div *dxTemplate="let info of 'detail'">
      <dx-tab-panel>
        <dxi-item title="Details">
          <app-consumer-master-details [modelId]="info.data.consumerId"></app-consumer-master-details>
        </dxi-item>

        <dxi-item title="Driver">
          <ng-container
            *ngTemplateOutlet="
              driverInfo;
              context: { $implicit: driverData(info.data.employeeId) | async }
            "></ng-container>
        </dxi-item>

        <dxi-item title="Vehicle">
          <ng-container
            *ngTemplateOutlet="
              vehicleInfo;
              context: { $implicit: vehicleData(info.data.vehicleId) | async }
            "></ng-container>
        </dxi-item>

        <dxi-item title="Trip">
          <ngx-json-viewer [json]="(info.data._trip || {}) | filterJson" [expanded]="false"></ngx-json-viewer>
        </dxi-item>

        <dxi-item title="Claim" *ngIf="info.data.vServiceType !== 'MEALS'">
          <ngx-json-viewer [json]="(info.data._trip?.__claim || {}) | filterJson" [expanded]="false"></ngx-json-viewer>
        </dxi-item>

        <!--        <dxi-item title="Meal Claims" *ngIf="info.data.vServiceType === 'MEALS'">-->
        <!--          <ngx-json-viewer [json]="(info.data._mealClaims || {}) | filterJson" [expanded]="false"></ngx-json-viewer>-->
        <!--        </dxi-item>-->
      </dx-tab-panel>
    </div>

    <!-- endregion Templates -->
  </dx-data-grid>
</app-content-w-header>

<!-- Templates -->

<ng-template #personEligibility let-model>
  <dx-data-grid
    width="100%"
    height="100%"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="true"
    [showBorders]="true"
    [dataSource]="model"
    [twoWayBindingEnabled]="false">
    <dxo-editing [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false"></dxo-editing>

    <dxo-state-storing
      [enabled]="true"
      type="localStorage"
      storageKey="69894271-f5fb-4e42-8a7c-584d2b5475e8"></dxo-state-storing>

    <!--            <dxo-sorting mode="none"></dxo-sorting>-->

    <!-- region Columns -->

    <dxi-column caption="Month" dataField="_month" dataType="string"></dxi-column>

    <dxi-column caption="Month Name" dataField="_monthName" dataType="string"></dxi-column>

    <dxi-column caption="MCO" dataField="mco" dataType="string"></dxi-column>

    <dxi-column caption="Broker" dataField="_broker" dataType="string"></dxi-column>

    <dxi-column caption="Status" dataField="status" dataType="string"></dxi-column>

    <dxi-column caption="Error" dataField="error" dataType="string"></dxi-column>

    <!-- endregion -->

    <!-- region Templates -->
    <!-- endregion -->
  </dx-data-grid>
</ng-template>

<ng-template #vehicleInfo let-model>
  <ngx-json-viewer [json]="model || {}" [expanded]="false"></ngx-json-viewer>
</ng-template>

<ng-template #driverInfo let-model>
  <ngx-json-viewer [json]="model || {}" [expanded]="false"></ngx-json-viewer>
</ng-template>
